import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const ExplainLoyalty = () => {
	const classes = useStyles();

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<img src={Images.icSubtitle} alt="icSubtitle" /> Diễn giải
			</Grid>
			<Grid classes={{ root: classes.content }}>
				<Grid classes={{ root: classes.title }}>
					<span>10.000 đồng/1 điểm</span> được hiểu là cứ 10.000 đồng
					doanh số, khách hàng quy đổi được 1 điểm
				</Grid>
				<Grid classes={{ root: classes.title }}>
					<span>20.000 đồng/1 điểm</span> được hiểu là cứ 20.000 đồng
					doanh số, khách hàng quy đổi được 1 điểm
				</Grid>
				<Grid classes={{ root: classes.title }}>
					<span>30.000 đồng/1 điểm</span> được hiểu là cứ 30.000 đồng
					doanh số, khách hàng quy đổi được 1 điểm
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(ExplainLoyalty);
